import React from "react";

import Picture from "../general/Picture";
import EpisodeCard from "./EpisodeCard";
import { useParallax } from "../hooks/motion";

//Photo banner with the season name (the photo scrolls slower than the page, as on the original site), then the episodes
const Season = ({ season }) => {
  const bannerRef = useParallax();
  const headingId = `${season.id}-heading`;

  return (
    <section
      id={season.id}
      className={"season"}
      aria-labelledby={headingId}
    >
      <div
        ref={bannerRef}
        className={"season-banner"}
      >
        <Picture
          name={season.banner}
          widths={[1000, 1800, 2600]}
          fallbackWidth={1400}
          sizes={"100vw"}
          alt={""}
          width={"1400"}
          height={"784"}
          className={"season-banner-img"}
        />
        <h2
          id={headingId}
          className={"season-title"}
        >
          {season.name}
        </h2>
      </div>

      <ul className={"episodes"}>
        {season.episodes.map((episode) => (
          <li key={episode.youtubeId}>
            <EpisodeCard episode={episode} />
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Season;
